import { IGetUserListResponse } from '../models/userRole.model'
import axiosInstance from '../utils/api-util/utilApi'

const config = { baseURL: process.env.REACT_APP_MASTER_SETUP_SERVICE_URL || '' }

export const getUserList = (roleId: string): Promise<IGetUserListResponse> => {
  return axiosInstance.get(`/api/User/GetUsers/${roleId}`, config)
}

export const getUserRoleList = (): Promise<any> => {
  return axiosInstance.get(`/api/UserRole`, config)
}

export const getFilteredUserRoleList = (payload: any): Promise<any> => {
  return axiosInstance.post(`/api/UserRole/filter`, payload, config)
}

export const getAllUserRole = (): Promise<any> => {
  return axiosInstance.get(`/api/UserRole/listAll`, config)
}

export const getUserRoleById = (userRoleId: string): Promise<any> => {
  return axiosInstance.get(`/api/UserRole/GetUserRoleDetail/${userRoleId}`, config)
}

export const fetchModuleItem = () => {
  return axiosInstance.get(`/api/ModuleItem`, config)
}

export const fetchSubModuleItem = (forClient: boolean) => {
  return axiosInstance.get(`/api/SubModuleItem/${forClient}`, config)
}

export const fetchSubModuleItemWithParams = (moduleName: string, bankOnlyAction: boolean) => {
  return axiosInstance.get(`/api/${moduleName}/SubModuleItem/${bankOnlyAction}`, config)
}

export const fetchPermission = (query?: { primaryGroupTypeCodeName?: string }) => {
  const queryString = query ? `?primaryGroupTypeCodeName=${query.primaryGroupTypeCodeName}` : ''
  return axiosInstance.get(`/api/Permission${queryString}`, config)
}

export const fetchPrimaryGroupType = () => {
  return axiosInstance.get(`/api/PrimaryGroupType`, config)
}

export const fetchUserNotificationType = (prefix: string) => {
  return axiosInstance.get(`/api/UserNotificationType/${prefix}`, config)
}

export const postCreateNewUserRole = (payload: any) => {
  return axiosInstance.post(`/api/UserRole/createNew`, JSON.stringify(payload), config)
}

export const putUpdateUserRole = (userRoleId: string | null, payload: any) => {
  return axiosInstance.put(`/api/UserRole/UpdateUserRole`, payload, config)
}

export const getUserRoleListAll = (): Promise<any> => {
  return axiosInstance.get(`/api/UserRole/listAll`, config)
}
